module.exports = __webpack_public_path__ + "assets/img/slogan-3d6ea78a.png";